import mshubPayload from '@/utils/mshubPayload'
import store from '@/Store'

const MosiaChatApi = (API) => {
  return {
    async historicoConversa (protocolo) {
      const url = store.getters['SetupApp/aplicacao'].rotas.historicoConversaChat.rota
      const payload = mshubPayload({})
      return API.get(url, {
        headers: {
          bundle: payload.sistema.app.bundle,
          instancia_aplicacao: store.getters['SetupApp/instanciaAplicacao'],
          protocolo: protocolo
        }
      })
    },
    async assinarUrlDownload (json) {
      const url = process.env.VUE_APP_OMNI_API_UTILITARIOS_AN + '/upload/preSigning'
      return API.post(url, json)
    }
  }
}

export default MosiaChatApi
